import React from 'react';
import { Link } from 'react-router-dom';


const refLines = [
  {
    source: 'arterialUp',
    value: 140
  },
  {
    source: 'arterialDown',
    value: 110
  }
];

const getRefValue = (name) => {
  const found = refLines.find(item => item.source === name);
  if (found === undefined) {
    console.error('Ref line not found?!');
    return;
  }
  return found.value;
}

const createTable = (data) => {

}

const getTableID = (id, name) => {
  return(
    <Link to={`/levels/${id}`}>
      Ver expediente
    </Link>
  )
}

export {getRefValue, createTable, getTableID};
